import React, { Component } from 'react';
import ReactDom from 'react-dom';
import ParameterErrors from '../errors/ParameterErrors';
import './Dialog.css';
import IconButton from './IconButton';
import DialogButton from './DialogButton';
import Urls from '../urls/Urls';
import { faBackward, faTimes} from '@fortawesome/free-solid-svg-icons';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class Dialog extends Component{
	constructor(props){
		super(props);
		const {preventInterraction, options, 
		//disposeOnHide, 
		message, title, className, onClickClose}=props;
		this._preventInterraction=(preventInterraction===undefined||preventInterraction===null)?true:preventInterraction;
		if(!options)throwNotProvided('options');
		this._options = options;
		//this._disposeOnHide = (disposeOnHide===undefined||disposeOnHide===null)?true:disposeOnHide;
		this._message = message;
		this._callbackClickClose = onClickClose;
		this._disposed=false;
		const buttons = options.map((option)=>{
			return (<DialogButton text={option.text} onClick={this._createOnClickForOption(option.callback)}/>);
		});
		this.state ={className:className, message:message, title:title, buttons:buttons};
		this._mapOptionHashToButton={};
		this._buttons=[];
		this.show = this.show.bind(this);
		this.dispose = this.dispose.bind(this);
		//this.hide = this.hide.bind(this);
		this._setVisible = this._setVisible.bind(this);
		this._handleClickButtonClose = this._handleClickButtonClose.bind(this);
		/*if(preventInterraction){
		
			var p={};
			p[S.ELEMENT]=element;
			new PreventInterraction(p);
			var preventInterractionElement = element;
			element = E.DIV();
			preventInterractionElement.appendChild(element);
		}*/
	}
	show(){
			this._setVisible(true);
			return this;
	}
	/*hide(){
		if(this._disposeOnHide){
			this.dispose();
			return;
		}
		this.setState({visible:false});
	}*/
	_handleClickButtonClose(){
		this._callbackClickClose&&this._callbackClickClose();
		this.dispose();
	}
	_createOnClickForOption(callback){
		return ()=>{
			callback&&callback();
			this.dispose();
		};
	}
	dispose(){
		if(this._disposed)return;
		this._disposed=true;
		ReactDom.unmountComponentAtNode(ReactDom.findDOMNode(this).parentNode);
	}
	_setVisible(value){
		this.setState({visible:value});
	}
	static create(props){
		props.ref = React.createRef();
		const element = React.createElement(Dialog, props);
		ReactDom.render(element , document.body.appendChild(document.createElement('div')));
		return element.ref;
	}
	render(){
		let className = "dialog";
		if(this.state.className)className+=` ${this.state.className}`;
		return (
			<div className={className} >
				<div className="inner">
					<div className="top">
						<IconButton className="close" imgUrl={Urls.assets+'icons/UI_Button_Exit.png'} onClick={this._handleClickButtonClose}></IconButton>
						<div className="title">{this.state.title}</div>
					</div>
					<div className="message">
						{this.state.message}
					</div>
					<div className="buttons">{this.state.buttons}</div>
				</div>
			</div>);
	}
}